import { ApiBase } from './ApiBase';
import { Injectable } from '@angular/core';
import { NodePosition } from '@apis/cas/generated';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NodePositionEndpoints extends ApiBase {
  public getNodePosition(dataInstanceUid: string): Observable<NodePosition> {
    return this.get<NodePosition>(`/game/${this.gameId}/data/node-position/${dataInstanceUid}`);
  }

  public updateNodePosition(dataInstanceUid: string, position: NodePosition): Observable<NodePosition> {
    return this.put<NodePosition>(`/game/${this.gameId}/data/node-position/${dataInstanceUid}`, position);
  }

  public deleteNodePosition(dataInstanceUid: string): Observable<void> {
    return this.delete<void>(`/game/${this.gameId}/data/node-position/${dataInstanceUid}`);
  }
}
